export default "__VITE_ASSET__YEDtPSKn__"